import { InjectionToken } from '@angular/core'

export interface Country {
  iso2code: string
  name: string
}

export const COUNTRIES = new InjectionToken('COUNTRIES')

export const countries = [
  {
    iso2code: 'aa',
    name: 'Afar',
  },
  {
    iso2code: 'ab',
    name: 'Abkhazian',
  },
  {
    iso2code: 'ae',
    name: 'Avestan',
  },
  {
    iso2code: 'af',
    name: 'Afrikaans',
  },
  {
    iso2code: 'ak',
    name: 'Akan',
  },
  {
    iso2code: 'am',
    name: 'Amharic',
  },
  {
    iso2code: 'an',
    name: 'Aragonese',
  },
  {
    iso2code: 'ar',
    name: 'Arabic',
  },
  {
    iso2code: 'as',
    name: 'Assamese',
  },
  {
    iso2code: 'av',
    name: 'Avaric',
  },
  {
    iso2code: 'ay',
    name: 'Aymara',
  },
  {
    iso2code: 'az',
    name: 'Azerbaijani',
  },
  {
    iso2code: 'ba',
    name: 'Bashkir',
  },
  {
    iso2code: 'be',
    name: 'Belarusian',
  },
  {
    iso2code: 'bg',
    name: 'Bulgarian',
  },
  {
    iso2code: 'bh',
    name: 'Bihari languages',
  },
  {
    iso2code: 'bi',
    name: 'Bislama',
  },
  {
    iso2code: 'bm',
    name: 'Bambara',
  },
  {
    iso2code: 'bn',
    name: 'Bengali',
  },
  {
    iso2code: 'bo',
    name: 'Tibetan',
  },
  {
    iso2code: 'br',
    name: 'Breton',
  },
  {
    iso2code: 'bs',
    name: 'Bosnian',
  },
  {
    iso2code: 'ca',
    name: 'Catalan; Valencian',
  },
  {
    iso2code: 'ce',
    name: 'Chechen',
  },
  {
    iso2code: 'ch',
    name: 'Chamorro',
  },
  {
    iso2code: 'co',
    name: 'Corsican',
  },
  {
    iso2code: 'cr',
    name: 'Cree',
  },
  {
    iso2code: 'cs',
    name: 'Czech',
  },
  {
    iso2code: 'cu',
    name: 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
  },
  {
    iso2code: 'cv',
    name: 'Chuvash',
  },
  {
    iso2code: 'cy',
    name: 'Welsh',
  },
  {
    iso2code: 'da',
    name: 'Danish',
  },
  {
    iso2code: 'de',
    name: 'German',
  },
  {
    iso2code: 'dv',
    name: 'Divehi; Dhivehi; Maldivian',
  },
  {
    iso2code: 'dz',
    name: 'Dzongkha',
  },
  {
    iso2code: 'ee',
    name: 'Ewe',
  },
  {
    iso2code: 'el',
    name: 'Greek, Modern (1453-)',
  },
  {
    iso2code: 'en',
    name: 'English',
  },
  {
    iso2code: 'eo',
    name: 'Esperanto',
  },
  {
    iso2code: 'es',
    name: 'Spanish; Castilian',
  },
  {
    iso2code: 'et',
    name: 'Estonian',
  },
  {
    iso2code: 'eu',
    name: 'Basque',
  },
  {
    iso2code: 'fa',
    name: 'Persian',
  },
  {
    iso2code: 'ff',
    name: 'Fulah',
  },
  {
    iso2code: 'fi',
    name: 'Finnish',
  },
  {
    iso2code: 'fj',
    name: 'Fijian',
  },
  {
    iso2code: 'fo',
    name: 'Faroese',
  },
  {
    iso2code: 'fr',
    name: 'French',
  },
  {
    iso2code: 'fy',
    name: 'Western Frisian',
  },
  {
    iso2code: 'ga',
    name: 'Irish',
  },
  {
    iso2code: 'gd',
    name: 'Gaelic; Scomttish Gaelic',
  },
  {
    iso2code: 'gl',
    name: 'Galician',
  },
  {
    iso2code: 'gn',
    name: 'Guarani',
  },
  {
    iso2code: 'gu',
    name: 'Gujarati',
  },
  {
    iso2code: 'gv',
    name: 'Manx',
  },
  {
    iso2code: 'ha',
    name: 'Hausa',
  },
  {
    iso2code: 'he',
    name: 'Hebrew',
  },
  {
    iso2code: 'hi',
    name: 'Hindi',
  },
  {
    iso2code: 'ho',
    name: 'Hiri Motu',
  },
  {
    iso2code: 'hr',
    name: 'Croatian',
  },
  {
    iso2code: 'ht',
    name: 'Haitian; Haitian Creole',
  },
  {
    iso2code: 'hu',
    name: 'Hungarian',
  },
  {
    iso2code: 'hy',
    name: 'Armenian',
  },
  {
    iso2code: 'hz',
    name: 'Herero',
  },
  {
    iso2code: 'ia',
    name: 'Interlingua (International Auxiliary Language Association)',
  },
  {
    iso2code: 'id',
    name: 'Indonesian',
  },
  {
    iso2code: 'ie',
    name: 'Interlingue; Occidental',
  },
  {
    iso2code: 'ig',
    name: 'Igbo',
  },
  {
    iso2code: 'ii',
    name: 'Sichuan Yi; Nuosu',
  },
  {
    iso2code: 'ik',
    name: 'Inupiaq',
  },
  {
    iso2code: 'io',
    name: 'Ido',
  },
  {
    iso2code: 'is',
    name: 'Icelandic',
  },
  {
    iso2code: 'it',
    name: 'Italian',
  },
  {
    iso2code: 'iu',
    name: 'Inuktitut',
  },
  {
    iso2code: 'ja',
    name: 'Japanese',
  },
  {
    iso2code: 'jv',
    name: 'Javanese',
  },
  {
    iso2code: 'ka',
    name: 'Georgian',
  },
  {
    iso2code: 'kg',
    name: 'Kongo',
  },
  {
    iso2code: 'ki',
    name: 'Kikuyu; Gikuyu',
  },
  {
    iso2code: 'kj',
    name: 'Kuanyama; Kwanyama',
  },
  {
    iso2code: 'kk',
    name: 'Kazakh',
  },
  {
    iso2code: 'kl',
    name: 'Kalaallisut; Greenlandic',
  },
  {
    iso2code: 'km',
    name: 'Central Khmer',
  },
  {
    iso2code: 'kn',
    name: 'Kannada',
  },
  {
    iso2code: 'ko',
    name: 'Korean',
  },
  {
    iso2code: 'kr',
    name: 'Kanuri',
  },
  {
    iso2code: 'ks',
    name: 'Kashmiri',
  },
  {
    iso2code: 'ku',
    name: 'Kurdish',
  },
  {
    iso2code: 'kv',
    name: 'Komi',
  },
  {
    iso2code: 'kw',
    name: 'Cornish',
  },
  {
    iso2code: 'ky',
    name: 'Kirghiz; Kyrgyz',
  },
  {
    iso2code: 'la',
    name: 'Latin',
  },
  {
    iso2code: 'lb',
    name: 'Luxembourgish; Letzeburgesch',
  },
  {
    iso2code: 'lg',
    name: 'Ganda',
  },
  {
    iso2code: 'li',
    name: 'Limburgan; Limburger; Limburgish',
  },
  {
    iso2code: 'ln',
    name: 'Lingala',
  },
  {
    iso2code: 'lo',
    name: 'Lao',
  },
  {
    iso2code: 'lt',
    name: 'Lithuanian',
  },
  {
    iso2code: 'lu',
    name: 'Luba-Katanga',
  },
  {
    iso2code: 'lv',
    name: 'Latvian',
  },
  {
    iso2code: 'mg',
    name: 'Malagasy',
  },
  {
    iso2code: 'mh',
    name: 'Marshallese',
  },
  {
    iso2code: 'mi',
    name: 'Maori',
  },
  {
    iso2code: 'mk',
    name: 'Macedonian',
  },
  {
    iso2code: 'ml',
    name: 'Malayalam',
  },
  {
    iso2code: 'mn',
    name: 'Mongolian',
  },
  {
    iso2code: 'mr',
    name: 'Marathi',
  },
  {
    iso2code: 'ms',
    name: 'Malay',
  },
  {
    iso2code: 'mt',
    name: 'Maltese',
  },
  {
    iso2code: 'my',
    name: 'Burmese',
  },
  {
    iso2code: 'na',
    name: 'Nauru',
  },
  {
    iso2code: 'nb',
    name: 'Bokmål, Norwegian; Norwegian Bokmål',
  },
  {
    iso2code: 'nd',
    name: 'Ndebele, North; North Ndebele',
  },
  {
    iso2code: 'ne',
    name: 'Nepali',
  },
  {
    iso2code: 'ng',
    name: 'Ndonga',
  },
  {
    iso2code: 'nl',
    name: 'Dutch',
  },
  {
    iso2code: 'nn',
    name: 'Norwegian Nynorsk; Nynorsk, Norwegian',
  },
  {
    iso2code: 'no',
    name: 'Norwegian',
  },
  {
    iso2code: 'nr',
    name: 'Ndebele, South; South Ndebele',
  },
  {
    iso2code: 'nv',
    name: 'Navajo; Navaho',
  },
  {
    iso2code: 'ny',
    name: 'Chichewa; Chewa; Nyanja',
  },
  {
    iso2code: 'oc',
    name: 'Occitan (post 1500)',
  },
  {
    iso2code: 'oj',
    name: 'Ojibwa',
  },
  {
    iso2code: 'om',
    name: 'Oromo',
  },
  {
    iso2code: 'or',
    name: 'Oriya',
  },
  {
    iso2code: 'os',
    name: 'Ossetian; Ossetic',
  },
  {
    iso2code: 'pa',
    name: 'Panjabi; Punjabi',
  },
  {
    iso2code: 'pi',
    name: 'Pali',
  },
  {
    iso2code: 'pl',
    name: 'Polish',
  },
  {
    iso2code: 'ps',
    name: 'Pushto; Pashto',
  },
  {
    iso2code: 'pt',
    name: 'Portuguese',
  },
  {
    iso2code: 'qu',
    name: 'Quechua',
  },
  {
    iso2code: 'rm',
    name: 'Romansh',
  },
  {
    iso2code: 'rn',
    name: 'Rundi',
  },
  {
    iso2code: 'ro',
    name: 'Romanian; Moldavian; Moldovan',
  },
  {
    iso2code: 'ru',
    name: 'Russian',
  },
  {
    iso2code: 'rw',
    name: 'Kinyarwanda',
  },
  {
    iso2code: 'sa',
    name: 'Sanskrit',
  },
  {
    iso2code: 'sc',
    name: 'Sardinian',
  },
  {
    iso2code: 'sd',
    name: 'Sindhi',
  },
  {
    iso2code: 'se',
    name: 'Northern Sami',
  },
  {
    iso2code: 'sg',
    name: 'Sango',
  },
  {
    iso2code: 'si',
    name: 'Sinhala; Sinhalese',
  },
  {
    iso2code: 'sk',
    name: 'Slovak',
  },
  {
    iso2code: 'sl',
    name: 'Slovenian',
  },
  {
    iso2code: 'sm',
    name: 'Samoan',
  },
  {
    iso2code: 'sn',
    name: 'Shona',
  },
  {
    iso2code: 'so',
    name: 'Somali',
  },
  {
    iso2code: 'sq',
    name: 'Albanian',
  },
  {
    iso2code: 'sr',
    name: 'Serbian',
  },
  {
    iso2code: 'ss',
    name: 'Swati',
  },
  {
    iso2code: 'st',
    name: 'Sotho, Southern',
  },
  {
    iso2code: 'su',
    name: 'Sundanese',
  },
  {
    iso2code: 'sv',
    name: 'Swedish',
  },
  {
    iso2code: 'sw',
    name: 'Swahili',
  },
  {
    iso2code: 'ta',
    name: 'Tamil',
  },
  {
    iso2code: 'te',
    name: 'Telugu',
  },
  {
    iso2code: 'tg',
    name: 'Tajik',
  },
  {
    iso2code: 'th',
    name: 'Thai',
  },
  {
    iso2code: 'ti',
    name: 'Tigrinya',
  },
  {
    iso2code: 'tk',
    name: 'Turkmen',
  },
  {
    iso2code: 'tl',
    name: 'Tagalog',
  },
  {
    iso2code: 'tn',
    name: 'Tswana',
  },
  {
    iso2code: 'to',
    name: 'Tonga (Tonga Islands)',
  },
  {
    iso2code: 'tr',
    name: 'Turkish',
  },
  {
    iso2code: 'ts',
    name: 'Tsonga',
  },
  {
    iso2code: 'tt',
    name: 'Tatar',
  },
  {
    iso2code: 'tw',
    name: 'Twi',
  },
  {
    iso2code: 'ty',
    name: 'Tahitian',
  },
  {
    iso2code: 'ug',
    name: 'Uighur; Uyghur',
  },
  {
    iso2code: 'uk',
    name: 'Ukrainian',
  },
  {
    iso2code: 'ur',
    name: 'Urdu',
  },
  {
    iso2code: 'uz',
    name: 'Uzbek',
  },
  {
    iso2code: 've',
    name: 'Venda',
  },
  {
    iso2code: 'vi',
    name: 'Vietnamese',
  },
  {
    iso2code: 'vo',
    name: 'Volapük',
  },
  {
    iso2code: 'wa',
    name: 'Walloon',
  },
  {
    iso2code: 'wo',
    name: 'Wolof',
  },
  {
    iso2code: 'xh',
    name: 'Xhosa',
  },
  {
    iso2code: 'yi',
    name: 'Yiddish',
  },
  {
    iso2code: 'yo',
    name: 'Yoruba',
  },
  {
    iso2code: 'za',
    name: 'Zhuang; Chuang',
  },
  {
    iso2code: 'zh',
    name: 'Chinese',
  },
  {
    iso2code: 'zu',
    name: 'Zulu',
  },
]
